import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Send } from "lucide-react";
import { toast } from "sonner";
import apiClient, { setAdminToken } from "@/lib/api";
import { IMAGES } from "@/data/images";

export default function AdminLogin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await apiClient.post("/auth/login", { email, password });
      setAdminToken(res.data.token);
      navigate("/admin");
    } catch {
      toast.error(t("common.error_generic"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-deepblue px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="bg-white rounded-3xl p-10 max-w-sm w-full shadow-2xl">
        <div className="flex items-center gap-2.5 mb-6 justify-center">
          <img src={IMAGES.logo} alt="Fastority" className="h-8 w-8" />
          <span className="font-heading font-extrabold text-lg text-slate900">Fastority</span>
        </div>
        <h1 className="font-heading font-bold text-xl text-center text-slate900 mb-1">{t("admin.login_title")}</h1>
        <p className="text-sm text-slate-500 text-center mb-6">{t("admin.login_subtitle")}</p>
        <div className="space-y-3">
          <input required type="email" data-testid="admin-login-email" placeholder={t("common.email")} value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-deepblue" />
          <input required type="password" data-testid="admin-login-password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-deepblue" />
        </div>
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full mt-6 inline-flex items-center justify-center gap-2 bg-coral text-white font-semibold px-6 py-3.5 rounded-full hover:scale-[1.01] transition-transform duration-300 disabled:opacity-60">
          <ShieldCheck size={16} /> {t("admin.login_cta")}
        </button>
      </form>
    </div>
  );
}
